<template>
  <div class="page_one" @click="play">
    <div class="video">
      <div class="video_gif">
        <img src="@/assets/img/MV3.gif" alt="" />
      </div>
      <video
        ref="video"
        width="100%"
        height="100%"
        muted="muted"
        loop="loop"
        autoplay="autoplay"
      >
        <!-- <source src="@/assets/img/MV2.webm" type="video/webm" /> -->
        <source src="@/assets/img/MV.mp4" type="video/mp4" />
      </video>
      <!-- <video
        ref="video"
        preload="preload"
        webkit-playsinline
        x5-video-player-type="h5"
        width="100%"
        height="100%"
        muted="muted"
        autoplay="autoplay"
        loop="loop"
      >
        <source src="@/assets/img/MV.mp4" />
      </video> -->
      <div class="mask">
        <transition enter-active-class="animate__animated animate__fadeInRight">
          <div class="content" v-show="pageIndex == 0">
            <p>UNIVERSE OF SUPERHEROES</p>
            <p class="q4">Q2 2022 Earnings Release</p>
            <div class="lvtiao">
              <img src="@/assets/img/lvtiao.png" alt="" />
            </div>
            <!-- <div class="whitepaper">
              <a
                href="https://www.miracles.games/miracle/Whitepaper.pdf"
                target="blank"
                >Whitepaper</a
              >
            </div> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "",
  computed: {
    ...mapState({
      pageIndex: (state) => state.page.pageIndex,
    }),
  },
  created() {},
  methods: {
    play() {
      this.$refs.video.play();
    },
    // toWhitepaper() {
    //   location.href = "/whitepaper.pdf";
    // },
  },
};
</script>
<style scoped lang="scss">
.page_one {
  // width: 10rem;
  width: 100%;
  // width: 1920px;
  // height: 5.625rem;
  height: 1080px;
  // position: relative;
  .video {
    width: 1920px;
    height: 1080px;
    .video_gif {
      display: none;
    }
  }
  .mask {
    position: relative;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);

    .content {
      position: absolute;
      z-index: 2;
      width: 75vw;
      height: 274px;
      font-family: icomoon;
      top: 399px;
      right: 179px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      // justify-content: flex-end;
      p {
        font-size: 80px;
        width: 100%;
        // height: 70px;
        color: #fff;
        text-align: right;
        font-weight: 700;
        line-height: 85px;
      }
      .q4 {
        font-size: 30px;
        color: #c9c9c9;
        height: 26px;
        margin-top: 28px;
        line-height: 26px;
      }
      .lvtiao {
        margin-top: 22px;
        img {
          width: 101px;
          height: 3px;
        }
      }
      .whitepaper {
        cursor: pointer;
        margin-top: 45px;
        width: 344px;
        height: 80px;
        border: 3px solid #ffffff;
        border-radius: 4px;
        color: #fff;
        font-size: 42px;
        text-align: center;
        line-height: 80px;
        a {
          color: #fff;
        }
      }
    }
  }
}

@media (max-width: 1199px) {
  .page_one {
    overflow: hidden;
    width: 100vw;
    height: 7.5rem;
    overflow: hidden;
    .video {
      width: 100vw;
      height: 7.5rem;
      .video_gif {
        display: block;
        width: 100%;
        height: 80%;
        margin-top: 0.88rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      video {
        display: none;
      }
    }
    .mask {
      position: relative;
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 7.5rem;
      background-color: rgba(0, 0, 0, 0.4);

      .content {
        position: absolute;
        z-index: 2;
        width: 90vw;
        height: 2.666667rem;
        font-family: icomoon;
        top: 2.666667rem;
        right: 1rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        p {
          font-size: 0.533333rem;
          width: 100%;
          height: 0.453333rem;
          color: #fff;
          text-align: right;
          font-weight: 700;
          line-height: 0.453333rem;
        }
        .q4 {
          font-size: 0.32rem;
          color: #c9c9c9;
          height: 0.186667rem;
          margin-top: 0.373333rem;
          line-height: 0.186667rem;
        }
        .lvtiao {
          margin-top: 0.133333rem;
          img {
            width: 1.333333rem;
            height: 2px;
          }
        }
        .whitepaper {
          cursor: pointer;
          margin-top: 0.293333rem;
          width: 2.293333rem;
          height: 0.533333rem;
          border: 0.026667rem solid #ffffff;
          border-radius: 4px;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          line-height: 0.533333rem;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .page_one {
    overflow: hidden;
    width: 100vw;
    height: 7.5rem;
    overflow: hidden;
    .video {
      width: 100%;
      height: 100%;
      .video_gif {
        display: block;
        width: 100%;
        height: 80%;
        margin-top: 0.88rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      video {
        display: none;
      }
    }
    .mask {
      position: relative;
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 7.5rem;
      background-color: rgba(0, 0, 0, 0.4);

      .content {
        position: absolute;
        z-index: 2;
        width: 90vw;
        height: 2.666667rem;
        font-family: icomoon;
        top: 2.666667rem;
        right: 1rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        p {
          font-size: 0.533333rem;
          width: 100%;
          height: 0.453333rem;
          color: #fff;
          text-align: right;
          font-weight: 700;
          line-height: 0.453333rem;
        }
        .q4 {
          font-size: 0.32rem;
          color: #c9c9c9;
          height: 0.186667rem;
          margin-top: 0.373333rem;
          line-height: 0.186667rem;
        }
        .lvtiao {
          margin-top: 0.133333rem;
          img {
            width: 1.333333rem;
            height: 2px;
          }
        }
        .whitepaper {
          cursor: pointer;
          margin-top: 0.293333rem;
          width: 2.293333rem;
          height: 0.533333rem;
          border: 0.026667rem solid #ffffff;
          border-radius: 4px;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          line-height: 0.533333rem;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page_one {
    overflow: hidden;
    width: 100vw;
    height: 7.5rem;
    overflow: hidden;
    .video {
      width: 100%;
      height: 100%;
      .video_gif {
        display: block;
        width: 100%;
        height: 80%;
        margin-top: 0.88rem;
      }
      video {
        display: none;
      }
    }
    .mask {
      position: relative;
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 7.5rem;
      background-color: rgba(0, 0, 0, 0.4);

      .content {
        // border: 1px solid red;
        position: absolute;
        z-index: 2;
        width: 90vw;
        height: 2.666667rem;
        font-family: icomoon;
        top: 2.666667rem;
        right: 1rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        p {
          font-size: 0.533333rem;
          width: 100%;
          height: 0.453333rem;
          color: #fff;
          text-align: right;
          font-weight: 700;
          line-height: 0.453333rem;
        }
        .q4 {
          font-size: 0.32rem;
          color: #c9c9c9;
          height: 0.186667rem;
          margin-top: 0.373333rem;
          line-height: 0.186667rem;
        }
        .lvtiao {
          margin-top: 0.133333rem;
          img {
            width: 1.333333rem;
            height: 2px;
          }
        }
        .whitepaper {
          cursor: pointer;
          margin-top: 0.293333rem;
          width: 2.293333rem;
          height: 0.8rem;
          border: 0.026667rem solid #ffffff;
          border-radius: 4px;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          line-height: 0.8rem;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
